/**
 * レバウェルスカウト同時登録の表示条件データ（NUT）。
 *
 * ロジックは matchScoutCondition.js に集約し、
 * ここには「どの値なら対象か」のデータだけを置く。
 *
 * ID は各 Model 定数に対応する安定値（変更されない前提）のため、
 * 突き合わせ先をコメントで明示したうえで生値で保持する。
 *
 * NUT の表示条件:
 *   - エリア : 一都三県
 *   - 資格   : 調理師(5)以外（type_id IN (1, 2, 3, 4)）
 *   - 雇用形態×時期（いずれか）:
 *       常勤 × （6ヶ月以内全て(1〜4) または 1年以内(5) または 1年以上先(6)）
 *       非常勤 × 時期不問
 *     ※常勤で対象外になるのは 良い求人があれば(7) のみ
 */
export const SCOUT_CONDITION = {
  // Prefecture::ID 一都三県: 11=埼玉 / 12=千葉 / 13=東京 / 14=神奈川
  prefectures: [11, 12, 13, 14],
  // NT LicenseType: 1=管理栄養士 / 2=栄養士 / 3=無資格 / 4=資格取得見込み（対象外: 5=調理師）
  licenses: [1, 2, 3, 4],
  // 時期は hope_jobchanges.type_id の実値:
  // 1ヶ月以内 = 1 / 2ヶ月以内 = 2 / 3ヶ月以内 = 3 / 6ヶ月以内 = 4 / 1年以内 = 5 / 1年以上先 = 6
  // （対象外: 7=良い求人があれば）
  workstyleTiming: [
    // 常勤(NT EmploymentWorkstyleType::ID_1) × 6ヶ月以内全て(1〜4) + 1年以内(5) + 1年以上先(6)
    { workstyles: [1], jobchanges: [1, 2, 3, 4, 5, 6] },
    // 非常勤(ID_2) × 時期不問
    { workstyles: [2], jobchanges: null },
  ],
};
